import { Lock } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import type { LockedResource } from '@/types/api/subscription'

interface LockedResourcesAlertProps {
  lockedResources: LockedResource[]
  onUpgradeClick?: () => void
}

export function LockedResourcesAlert({ lockedResources, onUpgradeClick }: LockedResourcesAlertProps) {
  if (!lockedResources || lockedResources.length === 0) return null

  return (
    <Card className="border-warning-500/50 bg-warning-50/50 shadow-none dark:bg-warning-950/20">
      <CardContent className="flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="rounded-xl bg-warning-500/10 p-2.5 text-warning-600 dark:text-warning-400">
            <Lock className="h-5 w-5" />
          </div>
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <h3 className="text-sm font-semibold text-foreground">
                {lockedResources.length} {lockedResources.length === 1 ? 'Resource' : 'Resources'} Locked
              </h3>
              <Badge variant="warning">Downgrade Limitation</Badge>
            </div>
            <p className="mt-1 text-xs text-muted-foreground">
              Some workspace resources exceed your active plan quota and are currently read-only or locked. Upgrade your plan to restore full operational access.
            </p>
          </div>
        </div>
        {onUpgradeClick && (
          <Button size="sm" variant="outline" onClick={onUpgradeClick} className="shrink-0">
            View Plans
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
